import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/priceMatrixActions';

// NB: The initial state is an array but both outcomes replace it with an *object*. The container
//     reads `state.alternativeHotels.hotels`, which is `undefined` on the array and defined after
//     either outcome, so the shape change is deliberate rather than a bug. Preserved as-is.
const alternativeHotelsSlice = createSlice({
  name: 'alternativeHotels',
  initialState: [],
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (_state, action) => ({ hotels: action.payload.alternativeHotels }))
      .addCase(initFailed, (_state, action) => ({ hotels: action.payload.alternativeHotels }));
  },
});

export default alternativeHotelsSlice.reducer;
